export default __webpack_public_path__ + "static/media/Ball-024-01png.7de161b9.png";